import angular, {IModule, IOnChangesObject, IScope} from "angular";
import {GruppeDatatjeneste} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {downgradeInjectable} from "@angular/upgrade/static";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {MatDialog} from "@angular/material/dialog";
import {NgZone} from "@angular/core";
import {AgendaelementModell, DokumentVersjonModell, EnkelGruppeModell, GenerellEpostTilMedlemmerSpesifikasjon, GruppeMedlemListeModell, MøteModell, SendEpostResultatModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {nårNg2ErLastet} from "web-ng2/delt/komponenter/ng2-boostrap/ng2-boostrap";
import {KopierMøteDialogKomponent} from "web-ng2/moduler/møte/modale/kopier-møte-dialog/kopier-møte-dialog";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {MedlemGjenåpneTilgangDialogKomponent} from "web-ng2/moduler/medlem/modale/medlem-gjenåpnetilgang-dialog/medlem-gjenåpnetilgang-dialog";
import {MedlemStengTilgangDialogKomponent} from "web-ng2/moduler/medlem/modale/medlem-stengtilgang-dialog/medlem-stengtilgang-dialog";
import {SendEpostDialogKomponent} from "web-ng2/moduler/epost/modale/send-epost-dialog/send-epost-dialog";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {Sakstidspunkter} from "felles-ng2/tjenester/Sakstidspunkter";
import {SaksdokumentDatatjeneste} from "felles-ng2/tjenester/datalager/SaksdokumentDatatjeneste";
import {combineLatestWith, firstValueFrom, from, Observable, switchMap} from "rxjs";
import {omsluttLeveringIAjsApplyAsync, takeUntilAjs$destroy} from "felles/ng2/rxjsHjelpere";
import {map} from "rxjs/operators";
import {filtrerBortNil} from "felles-ng2/støttefunksjoner/observable";
import {OppgaveOpprettDialogKomponent} from "web-ng2/moduler/oppgave/modale/oppgave-opprett-dialog/oppgave-opprett-dialog";
import {BeslutningOpprettDialogKomponent} from "web-ng2/moduler/beslutning/modale/beslutning-opprett-dialog/beslutning-opprett-dialog";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {OppgaveDatatjeneste} from "felles-ng2/tjenester/datalager/OppgaveDatatjeneste";
import {BeslutningDatatjeneste} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {Møtedialoger} from "web-ng2/moduler/møte/tjenester/Møtedialoger";
import {KopierSakDialogKomponent} from "web-ng2/moduler/sak/modale/kopier-sak-dialog/kopier-sak-dialog";
import {FlyttSakDialogKomponent} from "web-ng2/moduler/sak/modale/flytt-sak-dialog/flytt-sak-dialog";
import {HjelpDialogKomponent} from "web-ng2/delt/komponenter/dialog/hjelp-dialog/hjelp-dialog";
import {SignatarInformasjon, SigneringSignerDialogKomponent, SigneringSignerDialogRespons} from "web-ng2/moduler/signering/modale/signering-signer-dialog/signering-signer-dialog";
import {CdkScrollableSomTjeneste} from "web-ng2/tjenester/CdkScrollableSomTjeneste";
import {RegistrerDokumentArkfane, RegistrerSaksdokumentDialogKomponent} from "web-ng2/moduler/sak/modale/registrer-saksdokument-dialog/registrer-saksdokument-dialog";
import IInjectorService = angular.auto.IInjectorService;
import {PresentasjonsmodusTjeneste} from "web-ng2/tjenester/PresentasjonsmodusTjeneste";
import {ValgtSakRegister} from "web-ng2/tjenester/ValgtSakRegister";

/**
 * Registrerer ng2-tjenester som skal kunne brukes i ajs-kode.
 *
 * MERK at ng2 lastes ikke før første ng2-komponent instansieres. Dette medfører at
 * ng2-tjenester ikke kan registreres direkte i ajs-modulen som tjenester (via modul.service(..)) da
 * ng2 på dette tidspunktet ikke har blitt lastes.
 * Vi har en egen ng2-komponent {@link Ng2BoostrapKomponent} som refereres i index-web.html som indirekte
 * sørger for at ng2 blir lastet, men dette skjer etter at ajs-modulen definert i webModul.ts har blitt instansiert.
 * Av den grunn må vi lage egne tjenester for de ng2-tjenesten vi trenger tilgang til i ajs,
 * som laster ng2-tjenesten via $injector og da forhåpentligvis på et tidspunkt hvor Ng2BoostrapKomponent har blitt instansiert.
 *
 * Av denne grunn leverer ng2->ajs tjenestebroenes metoder promiser som først resolver når ng2 er lastet.
 *
 * Behovet for denne måten å gjøre kommer av at vi integrer ng2 via downgradeModule(..),
 * se https://angular.io/api/upgrade/static/downgradeModule
 *
 * Registernavnene som disse tjenestene er registrert under i ajs er definert i nedgraderteNg2TjenesterRegisternavn.ts for å unngå
 * importkonflikt (dersom regNavnene er definert i samme fil som NedgradertNg2Tjeneste-implementasjonene
 * vil storybook feile ved visning av stories.
 */
export function registrerNedgraderteNg2Tjenester(modul: IModule, nedgradertNg2Modul: string) {
    registrerTjenester(ng2RegNavn.GruppeDatatjenesteForAjs, GruppeDatatjenesteForAjs, GruppeDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.GruppemedlemDatatjenesteForAjs, GruppemedlemDatatjenesteForAjs, GruppemedlemDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.KommentarDatatjenesteForAjs, KommentarDatatjenesteForAjs, KommentarDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.MøteDatatjenesteForAjs, MøteDatatjenesteForAjs, MøteDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.SakDatatjenesteForAjs, SakDatatjenesteForAjs, SakDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.SakstidspunkterForAjs, SakstidspunkterForAjs, Sakstidspunkter, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.ValgtSakRegisterForAjs, ValgtSakRegisterForAjs, ValgtSakRegister, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.SaksdokumentDatatjenesteForAjs, SaksdokumentDatatjenesteForAjs, SaksdokumentDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.OppgaveDatatjenesteForAjs, OppgaveDatatjenesteForAjs, OppgaveDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.BeslutningDatatjenesteForAjs, BeslutningDatatjenesteForAjs, BeslutningDatatjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.MøtedialogerForAjs, MøtedialogerForAjs, Møtedialoger, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.CdkScrollableSomTjenesteForAjs, CdkScrollableSomTjenesteForAjs, CdkScrollableSomTjeneste, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.NgZoneForAjs, NgZoneForAjs, NgZone, modul, nedgradertNg2Modul)
    registrerTjenester(ng2RegNavn.PresentasjonsmodusTjenesteForAjs, PresentasjonsmodusTjenesteForAjs, PresentasjonsmodusTjeneste, modul, nedgradertNg2Modul)
    Ng2DialogTjenesterForAjs.registrerTjenester(modul, nedgradertNg2Modul);
}

abstract class NedgradertNg2Tjeneste<T> {
    protected constructor(private $injector: IInjectorService, private regNavn: string) {
    }

    tjeneste(): Promise<T> {
        return nårNg2ErLastet().then(() => this.$injector.get(ng2TjenesteRegNavn(this.regNavn)));
    }

    /** Kaller angitt 'tjenestekall' omsluttet i Ajs scope $applyAsync slik at ajs fanger opp endringer i $scope */
    tjenestekallOmsluttetIAjsApplyAsync(ajsScope: IScope, tjenestekall: (tjeneste: T) => void): void {
        this.tjeneste().then(tjeneste =>
          ajsScope.$applyAsync(() => tjenestekall(tjeneste)));
    }
}

export class MøteDatatjenesteForAjs extends NedgradertNg2Tjeneste<MøteDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.MøteDatatjenesteForAjs);
    }
}

export class GruppeDatatjenesteForAjs extends NedgradertNg2Tjeneste<GruppeDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.GruppeDatatjenesteForAjs);
    }
}

export class GruppemedlemDatatjenesteForAjs extends NedgradertNg2Tjeneste<GruppemedlemDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.GruppemedlemDatatjenesteForAjs);
    }
}

export class KommentarDatatjenesteForAjs extends NedgradertNg2Tjeneste<KommentarDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.KommentarDatatjenesteForAjs);
    }
}

export class SakDatatjenesteForAjs extends NedgradertNg2Tjeneste<SakDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.SakDatatjenesteForAjs);
    }
}

export class SakstidspunkterForAjs extends NedgradertNg2Tjeneste<Sakstidspunkter> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.SakstidspunkterForAjs);
    }
}

export class ValgtSakRegisterForAjs extends NedgradertNg2Tjeneste<ValgtSakRegister> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.ValgtSakRegisterForAjs);
    }
}

export class SaksdokumentDatatjenesteForAjs extends NedgradertNg2Tjeneste<SaksdokumentDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.SaksdokumentDatatjenesteForAjs);
    }
}

export class OppgaveDatatjenesteForAjs extends NedgradertNg2Tjeneste<OppgaveDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.OppgaveDatatjenesteForAjs);
    }
}

export class BeslutningDatatjenesteForAjs extends NedgradertNg2Tjeneste<BeslutningDatatjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.BeslutningDatatjenesteForAjs);
    }
}

export class MøtedialogerForAjs extends NedgradertNg2Tjeneste<Møtedialoger> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.MøtedialogerForAjs);
    }
}

export class CdkScrollableSomTjenesteForAjs extends NedgradertNg2Tjeneste<CdkScrollableSomTjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.CdkScrollableSomTjenesteForAjs);
    }
}

export class NgZoneForAjs extends NedgradertNg2Tjeneste<NgZone> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.NgZoneForAjs);
    }
}

export class PresentasjonsmodusTjenesteForAjs extends NedgradertNg2Tjeneste<PresentasjonsmodusTjeneste> {
    constructor($injector: IInjectorService) {
        super($injector, ng2RegNavn.PresentasjonsmodusTjenesteForAjs);
    }
}

/** Eksponerer MatDialog-baserte modale for bruk i ajs.
 * Merk at modal-komponenter som feks MøteOpprettDialogKomponent ikke kan benyttes direkte i ajs,
 * men må omsluttes av kall til NgZone.run for å rendres korrekt.
 * Metodene i denne tjenesten sørger for å gjøre dette. */
export class Ng2DialogTjenesterForAjs {
    static registrerTjenester(ajsModul: IModule, nedgradertNg2Modul: string) {
        //nedgrader MatDialog
        ajsModul.factory('ng2.MatDialog', downgradeInjectable(MatDialog, nedgradertNg2Modul));

        //registrer Ng2DialogTjenesterForAjs i ajs
        ajsModul.service(ng2RegNavn.Ng2DialogTjenesterForAjs, [regNavn.ng.$injector, Ng2DialogTjenesterForAjs]);
    }

    constructor(private $injector: IInjectorService) {
    }

    sendEpostDialog(overskrift: string, valgbareMedlemmer: GruppeMedlemListeModell[], valgteMedlemmer: GruppeMedlemListeModell[], sendEpost: (epostTilMedlemmerSpesifikasjon: GenerellEpostTilMedlemmerSpesifikasjon) => Promise<SendEpostResultatModell>): Promise<ReturnType<typeof SendEpostDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              SendEpostDialogKomponent.vis(matDialog, overskrift, valgbareMedlemmer, valgteMedlemmer, sendEpost));
        });
    }

    signerDokumentDialog(dokumentversjonPromise: DokumentVersjonModell, signatarInformasjonPromise: SignatarInformasjon): Promise<SigneringSignerDialogRespons> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() => {
                const dialog = SigneringSignerDialogKomponent.vis(
                  matDialog,
                  Promise.resolve(dokumentversjonPromise),
                  Promise.resolve(signatarInformasjonPromise));
                return firstValueFrom(dialog.beforeClosed());
            });
        });
    }

    møteKopierDialog(møte: MøteModell, møtetsGruppe: EnkelGruppeModell): Promise<ReturnType<typeof KopierMøteDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              KopierMøteDialogKomponent.vis(matDialog, møte, møtetsGruppe));
        });
    }

    sakKopierDialog(sak: AgendaelementModell): Promise<ReturnType<typeof KopierSakDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              KopierSakDialogKomponent.vis(matDialog, Promise.resolve(sak)));
        });
    }

    sakFlyttDialog(sak: AgendaelementModell): Promise<ReturnType<typeof FlyttSakDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              FlyttSakDialogKomponent.vis(matDialog, Promise.resolve(sak)));
        });
    }

    medlemGjenåpneTilgangDialogKomponent(medlem: GruppeMedlemListeModell): Promise<ReturnType<typeof MedlemGjenåpneTilgangDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              MedlemGjenåpneTilgangDialogKomponent.vis(matDialog, medlem));
        });
    }

    medlemStengTilgangDialogKomponent(medlem: GruppeMedlemListeModell, gruppe: EnkelGruppeModell): Promise<ReturnType<typeof MedlemStengTilgangDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              MedlemStengTilgangDialogKomponent.vis(matDialog, medlem, gruppe));
        });
    }

    oppgaveOpprettDialogKomponentVisOpprettUnderSak(sak: AgendaelementModell): Promise<ReturnType<typeof OppgaveOpprettDialogKomponent.visOpprettUnderSak>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              OppgaveOpprettDialogKomponent.visOpprettUnderSak(matDialog, sak));
        });
    }

    beslutningOpprettDialogKomponentVis(sak: AgendaelementModell, erForslag: boolean): Promise<ReturnType<typeof BeslutningOpprettDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              BeslutningOpprettDialogKomponent.vis(matDialog, sak, erForslag));
        });
    }

    registrerSaksdokumentDialogKomponent(sak: AgendaelementModell, aktivFane = RegistrerDokumentArkfane.genererte): Promise<ReturnType<typeof RegistrerSaksdokumentDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              RegistrerSaksdokumentDialogKomponent.vis(matDialog, sak, aktivFane));
        });
    }

    visHjelpDialog(): Promise<ReturnType<typeof HjelpDialogKomponent.vis>> {
        return nårNg2ErLastet().then(() => {
            const {ngZone, matDialog} = this.avhengigheter();

            return ngZone.run(() =>
              HjelpDialogKomponent.vis(matDialog));
        });
    }

    private avhengigheter() {
        const ngZone: NgZone = this.$injector.get(ng2TjenesteRegNavn(ng2RegNavn.NgZoneForAjs));
        const matDialog: MatDialog = this.$injector.get('ng2.MatDialog');
        return {ngZone, matDialog};
    }

}

/** Kaller nedgradert ng2-tjeneste og sørger for angitt 'tjenestekall' skjer i en $scope.$applyAsync blokk slik at endringer i $scope fanges opp av Ajs.
 * For bruk i Ajs komponent $onChanges der angitt 'endringer' er en observable som leverer verdier mottatt av $onChanges */
export function kallNedgradertNg2TjenesteVedEndring<R, T, TR>(
  /** Ajs scope vi kjører i */
  $scope: IScope,
  /** observable som leverer endringer mottatt via $onChanges, kaller er ansvarlig for å impl $onChanges og i denne metoden levere verdier til angitt 'endringer' */
  endringer: Observable<IOnChangesObject>,
  /** metode for transformering av endringshendelse levert via $onChanges, dersom denne metoden returnerer nil blir ikke 'tjenestekall' kalt */
  transformerHendelse: (endring: IOnChangesObject) => R,
  /** metode som returnerer nedgradert ng2-tjeneste */
  nedgradertTjeneste: Promise<T>,
  /** metode som kalles hver gang 'endringer' leverer en ikke-null verdi som er ulik forrige leverte verdi. */
  tjenestekall: (endring: R, nedgradertTjeneste: T) => Observable<TR>): Observable<TR> {
    return endringer
      .pipe(
        map(transformerHendelse),
        filtrerBortNil(),
        combineLatestWith(from(nedgradertTjeneste)),
        switchMap(([endring, nedgradertTjeneste]) => tjenestekall(endring, nedgradertTjeneste)),
        omsluttLeveringIAjsApplyAsync($scope),
        takeUntilAjs$destroy($scope)
      )
}

/** Kaller nedgradert ng2-tjeneste og sørger for angitt 'tjenestekall' skjer i en $scope.$applyAsync blokk slik at endringer i $scope fanges opp av Ajs.
 * For bruk i Ajs komponent $onChanges der angitt 'endringer' er en observable som leverer verdier mottatt av $onChanges */
export function kallNedgradertNg2TjenesteVed<R, T, TR>(
  /** Ajs scope vi kjører i */
  $scope: IScope,
  /** observable som leverer verdier som skal trigge 'tjenestekall' */
  endringer: Observable<R>,
  /** metode som returnerer nedgradert ng2-tjeneste */
  nedgradertTjeneste: Promise<T>,
  /** metode som kalles hver gang 'endringer' leverer en ikke-null verdi som er ulik forrige leverte verdi. */
  tjenestekall: (endring: R, nedgradertTjeneste: T) => Observable<TR>): Observable<TR> {
    return endringer
      .pipe(
        filtrerBortNil(),
        combineLatestWith(from(nedgradertTjeneste)),
        switchMap(([endring, nedgradertTjeneste]) => tjenestekall(endring, nedgradertTjeneste)),
        omsluttLeveringIAjsApplyAsync($scope),
        takeUntilAjs$destroy($scope)
      )
}


//private hjelpemetoder

function registrerTjenester(tjenesteWrapperRegNavn: string, tjenesteWrapperKlasse: any, tjenesteKlasse: any, ajsModul: IModule, nedgradertNg2Modul: string) {
    ajsModul.factory(ng2TjenesteRegNavn(tjenesteWrapperRegNavn), downgradeInjectable(tjenesteKlasse, nedgradertNg2Modul));
    ajsModul.service(tjenesteWrapperRegNavn, [regNavn.ng.$injector, tjenesteWrapperKlasse]);
}

function ng2TjenesteRegNavn(gn2TjenesteWrapperRegNavn: string) {
    return gn2TjenesteWrapperRegNavn + '.tjeneste';
}
